function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { keyframes } from '@emotion/core';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import typography from '../utils/typography';
import { useTheme } from '@veneer/theme';
var slideInKeyframes = keyframes({
  from: {
    transform: 'translateX(110%)',
    visibility: 'visible'
  },
  to: {
    transform: 'translateX(0)'
  }
});
var slideOutKeyframes = keyframes({
  from: {
    transform: 'translateX(0)'
  },
  to: {
    transform: 'translateX(110%)',
    visibility: 'hidden'
  }
});
var types = {
  help: 'primary',
  positive: 'positive',
  negative: 'negative',
  warning: 'warning'
};
var useStyles = _ref => {
  var {
    isVeneerButton,
    type
  } = _ref;
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  return React.useMemo(() => {
    var _theme$palette;
    var iconColor = type === 'informative' ? (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.foreground.light : theme.palette[types[type]].default;
    return {
      root: _objectSpread(_objectSpread({
        alignItems: 'flex-start',
        animationDuration: '400ms',
        animationFillMode: 'forwards',
        backgroundColor: theme.palette.background.container,
        borderColor: 'transparent'
      }, isHc && {
        borderColor: theme.palette.foreground.default
      }), {}, {
        borderRadius: theme.borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxSizing: 'border-box',
        color: theme.palette.foreground.default,
        display: 'flex',
        marginBottom: theme.orbitalFive,
        padding: "calc(".concat(theme.layout.size1, " - 1px)"),
        width: '100%',
        zIndex: theme.elevation.toast
      }, highContrastMediaQuery(theme)),
      entering: {
        animationName: slideInKeyframes
      },
      exiting: {
        animationName: slideOutKeyframes
      },
      entered: {},
      exited: {},
      unmounted: {},
      icon: _objectSpread({
        fill: type && iconColor,
        marginLeft: "calc(".concat(theme.orbitalTwo, " - 1px)"),
        marginRight: theme.orbitalFour,
        marginTop: "calc(".concat(theme.orbitalTwo, " - 2px)")
      }, isHc && _objectSpread({}, type === 'help' && {
        fill: theme.palette.foreground.default
      })),
      text: {
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        margin: "".concat(theme.orbitalTwo, " 0"),
        marginRight: theme.orbitalTwo,
        wordBreak: 'break-word'
      },
      title: _objectSpread({}, typography(theme).label),
      subtitle: _objectSpread({
        color: theme.palette.foreground.medium
      }, typography(theme).captionSmall),
      action: {
        color: theme.palette.primary.default,
        marginRight: theme.layout.size1,
        marginTop: !isVeneerButton ? "calc(".concat(theme.orbitalTwo, " - 2px)") : undefined,
        a: {
          color: 'inherit'
        },
        button: {
          minWidth: 'auto'
        }
      },
      closeButton: {
        padding: "calc(".concat(theme.layout.size1, " + 2px)")
      }
    };
  }, [isHc, isVeneerButton, theme, type]);
};
export default useStyles;